import { useEffect, useState } from "react";
import { resolveFileUrl } from "components/brief/util/fileUrl";

const PREVIEW_STYLE = `
  <style>
    html::-webkit-scrollbar,
    body::-webkit-scrollbar {
      display: none !important;
    }
  </style>
`;

// The prototype is self-contained by contract -- inline CSS and JS, images as data URIs,
// Google Fonts as the only external request -- so it needs no <base>. It must not get one
// either: with a base pointing at this page, every `href="#screen"` inside the prototype
// resolves to the brief's own URL instead of a fragment of the frame's document, so a
// click navigated the frame to the brief, which drew the prototype in another frame, and
// so on down.
const getPreviewHtml = (text) => {

  if (text.includes("<head"))
    return text.replace(/<head([^>]*)>/i, `<head$1>${PREVIEW_STYLE}`);

  return `${PREVIEW_STYLE}${text}`;

};

// Downloads the prototype and hands it over as a blob URL instead of a `srcDoc` string.
// A srcDoc attribute carries the whole generated document -- often megabytes -- as a DOM
// attribute that React writes on every mount and the parser reads back inline; the blob
// keeps it out of the tree and lets the browser stream it.
const usePrototypeDocument = (file) => {

  const fileUrl = resolveFileUrl(file?.url);

  const [documentUrl, setDocumentUrl] = useState(null);
  const [isLoadError, setIsLoadError] = useState(false);

  useEffect(() => {

    setDocumentUrl(null);
    setIsLoadError(false);

    if (!fileUrl)
      return () => {};

    let isMounted = true;
    let objectUrl = null;

    fetch(fileUrl)
      .then((response) => response.text())
      .then((text) => {
        if (!isMounted)
          return;

        objectUrl = URL.createObjectURL(new Blob([getPreviewHtml(text)], { type: "text/html" }));
        setDocumentUrl(objectUrl);
      })
      .catch(() => {
        if (isMounted)
          setIsLoadError(true);
      });

    return () => {
      isMounted = false;
      if (objectUrl)
        URL.revokeObjectURL(objectUrl);
    };

  }, [fileUrl]);

  return { documentUrl, isLoadError };

};

export { usePrototypeDocument };
